import React from "react";
import { Modal, Button, FormGroup, FormControl, ControlLabel } from "react-bootstrap";

export const ModalNotificationsEvents = ({ show, onClose, notificationEvent, onChange }) => {
  if (!notificationEvent) return null;

  const handleChange = (field, value) => {
    if (onChange) {
      onChange({ ...notificationEvent, [field]: value });
    }
  };

  return (
    <Modal show={show} onHide={onClose} backdrop="static" keyboard={false} dialogClassName="rounded-modal">
      <Modal.Header closeButton>
        <Modal.Title>Notificación</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup controlId="formModule">
          <ControlLabel>Módulo</ControlLabel>
          <FormControl
            type="text"
            value={notificationEvent.module}
            onChange={(e) => handleChange("module", e.target.value)}
          />
        </FormGroup>

        <FormGroup controlId="formNotification">
          <ControlLabel>Notificación</ControlLabel>
          <FormControl
            type="text"
            value={notificationEvent.notifications}
            onChange={(e) => handleChange("notification", e.target.value)}
          />
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onClose}>Cerrar</Button>
      </Modal.Footer>
    </Modal>
  );
};
